import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('@@xver/error');

export const setErrorMessage = actionCreator<string | undefined>('setErrorMessage');
